import React from 'react';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, ButtonCore } from '@saviynt/design-system';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import MenuItems from './MenuItems/MenuItems';
import UserDetails from './UserDetails/UserDetails';
import useDisplayName from '../../utils/useDisplayName';

import './Profile.css';

const useStyles = makeStyles(() => ({
  profileIcon: {
    padding: 0,
    outline: (open) => (open ? '2px solid #3751FF' : '0'),
    /* TODO: Remove !important if Metronic from bootstrap is removed*/
    borderRadius: '4rem !important',
    border: 0,
    '&:focus': { outlineOffset: '.125rem' },
  },
}));

const Profile = ({ intl }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const classes = useStyles(anchorEl || false);

  let { profileImage } = useSelector((state) => state.profile);
  const displayName = useDisplayName();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonCore
        ariaLabel={intl.formatMessage({ id: 'Profile.AriaLabel.Profile', defaultMessage: 'profile' })}
        ariaControls="long-menu"
        ariaHaspopup="true"
        ariaExpanded={Boolean(anchorEl)}
        onClick={handleClick}
        className={classes.profileIcon}
        dataTestId="profile"
      >
        <Avatar size="medium" className="Profile-avatar" src={profileImage ? profileImage : null}>
          {displayName}
        </Avatar>
      </ButtonCore>
      <DropDownMenu anchorEl="body" open={Boolean(anchorEl)} onClose={handleClose}>
        <UserDetails />
        <MenuItems />
      </DropDownMenu>
    </>
  );
};

export default injectIntl(Profile);
